export default {
  methods: {
    getExcelFields() {
      return {
        [this.$t("mainProject.title")]: {
          field: "mainProject.title",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("project.model")]: {
          field: "project.model",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("project.createdDate")]: {
          field: "createdDate",
          callback: (value) => {
            return this.$date.format(value);
          },
        },
        [this.$t("project.updatedAt")]: {
          field: "updatedDate",
          callback: (value) => {
            return this.$date.format(value || new Date());
          },
        },
      };
    },
  },
};
